import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input } from "antd";
import { API_URL } from "../../config";
import AntDesignTable from "../common/antTable/AntDesignTable";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const TransactionContainer = () => {
  const { t } = useTranslation();
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${API_URL}/credit/transactions/`);
        setTransactions(response.data);
        setFilteredTransactions(response.data);
      } catch (error) {
        console.error(
          "There was an error fetching the transaction data!",
          error,
        );
      }
    };

    fetchTransactions();
  }, []);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filteredData = transactions.filter(
      (transaction) =>
        transaction.payment_intent_id.toLowerCase().includes(value) ||
        transaction.patient_id.toString().includes(value),
    );

    setFilteredTransactions(filteredData);
  };

  const columns = [
    {
      title: t("tableHeader.id"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("tableHeader.amount"),
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: t("tableHeader.PatientID"),
      dataIndex: "patient_id",
      key: "patient_id",
    },
    {
      title: t("tableHeader.paymentIntentID"),
      dataIndex: "payment_intent_id",
      key: "payment_intent_id",
    },
    {
      title: t("tableHeader.creditId"),
      dataIndex: "credit_id",
      key: "credit_id",
    },
    {
      title: t("common.creationTime"),
      dataIndex: "creation_datetime",
      key: "creation_datetime",
      render: (value) =>
        value ? dayjs(value).format("YYYY-MM-DD HH:mm") : "-",
    }
  ];

  return (
    <React.Fragment>
      <Input
        placeholder={t("search.searchByPaymentOrPatient")}
        value={searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 16, width: 320 }}
      />

      <AntDesignTable columns={columns} tableData={filteredTransactions} />
    </React.Fragment>
  );
};

export default TransactionContainer;
